import type { FunctionComponent } from 'react'
import React from 'react'
import { Picture, TypographyV2 as Typography } from '@which/seatbelt'

import classNames from 'classnames'

import globalStyles from '../../styles/GlobalStyles.module.scss'
import type { ImageWithQuestionProps } from '../../types/toolTypes'
import styles from './ImageWithQuestion.module.scss'

export const ImageWithQuestion: FunctionComponent<ImageWithQuestionProps> = ({
  image,
  optionalTag,
  optionalText = '(optional)',
  title,
  titleStyle = 'sb-text-heading-large',
  titleTag = 'p',
  bottomMargin = globalStyles.spacing40,
  pictureClass = '',
  titleRef,
  className,
}) => {
  return (
    <div
      className={classNames(
        bottomMargin,
        styles.imageWithQuestion,
        globalStyles.maxWidth,
        className
      )}
      data-testid="tool-image-and-question"
    >
      <Picture
        {...image}
        aspectRatioMain="two-to-one"
        className={classNames(globalStyles.spacing30, styles.pictureContainer, pictureClass)}
        lazyLoad={false}
      />
      <div className="sb-text-align-center">
        <Typography
          dangerouslySetInnerHTML={{ __html: title }}
          forwardRef={titleRef}
          tabIndex={-1}
          tag={titleTag}
          textStyle={titleStyle}
        />
        {optionalTag && (
          <Typography
            className={styles.imageWithQuestionOptional}
            textStyle="sb-text-body-default-strong"
          >
            {optionalText}
          </Typography>
        )}
      </div>
    </div>
  )
}
